import clsx from 'clsx'
import Link from 'next/link'

import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { ProductReview } from 'src/components/ProductDetail/ProductReview'
import { Text } from 'src/components/Text/Text'

import styles from './BottomInfoSection.module.scss'

export const BottomInfoSection = () => {
  const customerReviews = [
    {
      id: '0',
      productSku: '',
      title: 'Gutes Geschenk',
      comment:
        'Ich habe das Kaffee Abo verschenkt und es kam sehr gut an. Den Gutschein konnte ich noch am selben Tag zu Hause ausdrucken und verschenken. Funktioniert einwandfrei, auf jeden Fall eine Empfehlung für ein schnelles Geschenk mit viel Freude.',
      rating: 5,
      submittedAt: '2023-01-15T06:44:55.000Z',
      customer: { name: 'Hendrik' },
    },
    {
      id: '1',
      productSku: '',
      title: 'Endlich ein Abo zum verschenken',
      comment:
        'Yeah, wie geil ist das denn? Danke, dass ihr mich erhört habt und ich nun endlich ein Kaffeeabo verschenken kann! Und dann auch noch mit unterschiedlichen Kaffees - ausgezeichnet. Wurde sofort gekauft und bin mir sicher, dass die Beschenkte sich nen Ast freuen wird.',
      rating: 5,
      submittedAt: '2023-12-28T09:42:35.000Z',
      customer: { name: 'Ben' },
    },
  ]

  return (
    <Container columns="2" className={styles.container}>
      <section>
        <Headline variant="h2">Noch Fragen?</Headline>
        <details>
          <summary>Wie funktioniert das Geschenkabo?</summary>
          <Text variant="p" className={styles.leftPadding}>
            In ein paar Schritten bescherst du deinen Liebsten eine richtig gute Überraschung:
          </Text>
          <ol className={clsx('list', styles.leftPadding)}>
            <li>Du wählst auf der Seite das passende Geschenkabo (Zubereitungsart und Anzahl der Lieferungen) aus.</li>
            <li>
              Du gibst folgende Angaben ein:
              <br />
              • &nbsp; Vor- und Nachname der / des Beschenkten
              <br />
              • &nbsp; E-Mail Adresse der / des Beschenkten
              <br />
              • &nbsp; deine persönliche Nachricht zum Geschenk
              <br />
              • &nbsp; deinen Namen
              <br />• &nbsp; das gewünschte Datum für den Versand des Geschenkabos per E-Mail (z. B. 24. Dezember um
              11:30 Uhr)
            </li>
            <li>Du zahlst über unsere Seite.</li>
            <li>
              Sobald die Zahlung bestätigt ist, erhältst du eine Bestätigung mit einer Geschenkkarte als PDF zum
              Ausdrucken - falls du auch etwas Analoges übergeben möchtest.
            </li>
            <li>🎁 Verschenke das Geschenkabo und eine neue Kaffeewelt an deine Liebsten</li>
            <li>
              Am gewünschten Datum bekommt die / der Beschenkte eine E-Mail mit einem Link, um das Geschenkabo
              einzulösen. Nun kann die gewünschte Lieferadresse und der Starttermin des Abos eingegeben werden.
            </li>
            <li>
              Nach der Einlösung erfolgt die erste Lieferung und dann alle 4 Wochen eine weitere (2 x 250 g je
              Lieferung) - so lange, wie du eben verschenkt hast. (Wir empfehlen vor allem die 6-Monats-Variante.)
            </li>
          </ol>
          <Text variant="p" className={styles.leftPadding}>
            Danke für dein Vertrauen und deine Unterstützung unserer sozialen Projekte.
          </Text>
        </details>
        <details>
          <summary>In welche Länder versenden wir?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Das Kaffee-Geschenkabo ist derzeit nur für Empfänger:innen in Deutschland und Österreich verfügbar.
          </Text>
        </details>
        <details>
          <summary>Welche Kaffees werden im Geschenkabo versendet?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Überraschung! Mit jeder Lieferung senden wir an deine Liebsten drei oder sechs Monate lang unterschiedliche
            Kaffees (2 Packungen à 250 g, nur ganze Bohnen). Wählst du die 9- oder 12-Monats-Variante, kommt es zu
            Wiederholungen.
          </Text>
        </details>
        <details>
          <summary>Was ist das beste Abo zum Verschenken?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Wir empfehlen das 6-Monate-Geschenkabo: Damit sicherst du eine perfekte Reise durch unser Portfolio,
            inklusive wechselnder Limited Editions, immer frisch geröstet von unserem ausgezeichneten Röstmeister.
          </Text>
        </details>
        <details>
          <summary>Für wen ist das Geschenkabo?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Für alle Kaffeeliebhaber:innen, für deine Familie, für deine Freund:innen, für deine Kolleg:innen, für deine
            Eltern - für wen du willst. Oder auch für dich. Die perfekte Rundreise durch unsere Kaffeewelt für alle, die
            Abwechslung lieben.
          </Text>
        </details>
        <details>
          <summary>Ist auch eine Karte dabei?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Aber klar: Nach der Zahlung des Geschenkabos senden wir dir eine Bestellbestätigung inklusive einer
            PDF-Karte zum Ausdrucken.
          </Text>
        </details>
        <details>
          <summary>Ich kenne die E-Mail-Adresse der / des Beschenkten nicht.</summary>
          <Text variant="p" className={styles.leftPadding}>
            Kein Problem: Wir benötigen eine E-Mail-Adresse, mit der das Geschenkabo verknüpft wird und an die wir die
            Geschenkbenachrichtigung senden. Kennst du die E-Mail-Adresse der / des Beschenkten nicht, oder möchtest du
            sie nicht angeben, füge deine Adresse ein und informiere die / den Beschenkte:n. Beim Einlösen des Abos kann
            auch die E-Mail-Adresse geändert werden, so dass die Versandbenachrichtigung zu jeder Lieferung ans passende
            Postfach geht.
          </Text>
        </details>
        <details>
          <summary>Ich weiß nicht, welche Zubereitungsart passend ist.</summary>
          <Text variant="p" className={styles.leftPadding}>
            Kein Problem, hier die Lösung:
          </Text>
          <ul className={clsx('list', styles.leftPadding)}>
            <li>
              <i>Filter </i>
              ist einen Volltreffer für: French Press, Filterkaffeemaschine, Handfilter, Pour-Over, Chemex, Aeropress
            </li>
            <li>
              <i>Espresso </i>
              ist einen Volltreffer für: Siebträgermaschine, Espressokocher, Mokkakanne
            </li>
            <li>
              <i>Vollautomaten </i>
              ist einen Volltreffer für: Kaffeevollautomaten 😄
            </li>
          </ul>
        </details>
        <details>
          <summary>Kann ich das Geschenkabo für mich kaufen?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Ja, definitiv! Füge deine E-Mail-Adresse im Bestellprozess als Empfänger:in ein und entdecke unsere Kaffees.
          </Text>
          <Text variant="p" className={styles.leftPadding}>
            Danke für dein Vertrauen und deine Unterstützung unserer sozialen Projekte.
          </Text>
        </details>
        <details>
          <summary>Wann starten die Lieferungen?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Die erste Lieferung erfolgt direkt nach Einlösung des Geschenkabos durch die / den Beschenkte:n. Danach
            erfolgt automatisch alle vier Wochen eine Lieferung mit unterschiedlichen Kaffees aus unserem Portfolio.
          </Text>
        </details>
        <details>
          <summary>Wie kann ich das Geschenkabo zahlen?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Das Geschenkabo kannst du per PayPal zahlen.
          </Text>
        </details>
        <details>
          <summary>Wird das Abo automatisch verlängert?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Nein, das Abo endet nach der gewählten Laufzeit automatisch, eine Kündigung ist nicht notwendig.
          </Text>
        </details>
        <details>
          <summary>Fallen Zusatzkosten für die Lieferung an?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Die Versandkosten sind bereits inklusive. Wir versenden klimaneutral mit GoGreen von DHL. Das Kaffee-Abo
            wird umgehend nach der Einlösung durch die / den Beschenkte:n verschickt, so dass die erste Lieferung
            innerhalb von 1 - 3 Werktagen eintreffen wird.
          </Text>
        </details>
        <details>
          <summary>Kann die / der Beschenkte das Geschenkabo pausieren?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Ja, das ist möglich: Kontaktiere unseren Kundenservice über das Kontaktformular, und wir werden das
            Geschenkabo bis zu 60 Tage pausieren. Danach läuft das Abo automatisch weiter. Bitte beachte: Wir können das
            Geschenkabo nur einmal pausieren.
          </Text>
        </details>
        <details>
          <summary>Was unterscheidet Coffee Circle von anderen Röstereien?</summary>
          <Text variant="p" className={styles.leftPadding}>
            Coffee Circle vereint seit 2010 die Liebe zum Kaffee mit der Liebe zu den Menschen, die ihn anbauen. 1 € pro
            kg Kaffee investieren wir in die nachhaltige Verbesserung der Lebensbedingungen der Kaffeefarmer:innen.
          </Text>
          <Text variant="p" className={styles.leftPadding}>
            Bisher konnten wir so gut 4 Millionen Euro Spenden einnehmen, die wir in Bildung, Zugang zu Wasser und
            Hygieneschulungen sowie in Maßnahmen für nachhaltigen Kaffeeanbau und Qualitätssteigerung investiert haben.
            Wir pflegen stets direkte Handelsbeziehungen zu unseren Partner:innen und zahlen überdurchschnittlich hohe
            Preise (weit mehr als Fair Trade) für deren Rohkaffee.
          </Text>
          <Text variant="p" className={styles.leftPadding}>
            Durch den Kauf des Geschenkabos machst du die Welt schöner, während deine Liebsten die besten Kaffees
            trinken, immer frisch geröstet.
          </Text>
          <Text variant="p" className={styles.leftPadding}>
            Du willst es genauer wissen? Aber gern:
          </Text>
          <ul className={styles.leftPadding}>
            <li>
              <Link href="/de/e/projekte">Was machen wir anders?</Link>
            </li>
            <li>
              <Link href="/de/e/projekterfolge">Das haben wir bisher erreicht</Link>
            </li>
          </ul>
        </details>
      </section>
      <div>
        {customerReviews.map((review) => (
          <ProductReview review={review} key={review.id} />
        ))}
      </div>
    </Container>
  )
}
